import {
  Observable
} from "rxjs/Observable"
import {
  // eslint-disable-next-line no-unused-vars
  ofType
} from "rxjs"

import UserActions, {
  PURCHASE_CREDITS
} from "../actions/user"

const purchaseCreditsEndpoint = `${process.env.REACT_APP_API_HOST}/user/credits`

export const userPurchaseCreditsEpic = action$ =>
  action$.ofType(PURCHASE_CREDITS)
  .switchMap(({
    payload
  }) => {
    return Observable.ajax.post(purchaseCreditsEndpoint, {
        quantity: payload
      }, {
        Authorization: `Bearer ${localStorage.getItem("token")}` || ""
      })
      .map(response => UserActions.purchaseCreditsSuccess(response.response))
      .catch(error => Observable.of(UserActions.purchaseCreditsFailure(error)))
  })
